import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home4',
  templateUrl: './home4.component.html',
  styleUrls: ['./home4.component.scss']
})
export class Home4Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home4-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home4-page');
  }
}
